import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../services/brdsql.service';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
declare var $: any;

@Component({
  selector: 'app-get-fert3',
  templateUrl: './get-fert3.component.html',
  styleUrls: ['./get-fert3.component.css']
})
export class GetFert3Component implements OnInit {

  //dateEnd = "30-06-2022";
  cpdata: any;
  cpbyone?: any = [];
  chemicaData: any;
  supzoneData: any;
  fmgetFactorNow: any;
  StockData: any;
  Stockselect = '';
  supzoneselect = '';
  supcodeselect = '';
  fmcodeselect = '';
  ckOver = false;
  s_fmcode = '';
  @ViewChild('tb_data') tb_data!: ElementRef;
  @ViewChild('tb_fmgetFactor') tb_fmgetFactor!: ElementRef;

  constructor(private brdservice: BrdsqlService,private spinner: NgxSpinnerService) {
  //  this.supzoneselect = localStorage.getItem('supzone');
    this.supcodeselect = localStorage.getItem('supcode');
    //this.fmcodeselect = localStorage.getItem('fmcodeselect');
  //  this.Stockselect = localStorage.getItem('getStockBRD');
  }

  ngOnInit(): void {
    this.chemicalList();
   // this.supzoneList();
    this.StockList();
  }



  // สูตรปุ๋ยเคมีสำหรับ select
  chemicalList() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=stock_id,description,amt_in,amt_out,CntUnitMsr,group_type,per_unit&f=[dbo].[stock]&w=([amt_in]>0or[amt_out]>0)and[group_type]=1";
    axios.get(url).then(res => {
        this.chemicaData = res.data;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
    /*
    this.brdservice.chemicalList()
      .subscribe({
        next: (data: any) => {
          this.chemicaData = data.recordset;
        }
      })*/
  };

 /* // supzone select
  supzoneList() {
    this.brdservice.getSupzone()
      .subscribe({
        next: (data: any) => {
          this.supzoneData = data.recordset;
        }
      })
  };
*/
//รายการStockโซน
  StockList() {
    this.brdservice.getStockBRD()
      .subscribe({
        next: (data: any) => {
          this.StockData = data.recordset;
        }
      })
  };
  // ข้อมูลแปลงที่ขอปุ๋ยรอบ3 ได้ในเขต
  cpGetfert3(fmcode): void {
    //console.log('f : ',f);
    //localStorage.setItem('fmcodeselect',f.fmcode);
    this.s_fmcode = fmcode;
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp6667_getFert3]&w=fmcode='" + fmcode + "' order by supzone,intlandno ";
    axios.get(url).then(res => {
      if(res.data.length>0){
        this.cpdata = res.data;
        setTimeout(() => {
          $(this.tb_data.nativeElement).DataTable();
        }, 10);
        setTimeout(() => {
          this.fmgetFactor();
        }, 400);
      }
      else this.cpdata = [];
    }).catch(err => { console.log(err); })
    this.spinner.hide();    
  };

  // ข้อมูลการเบิกปัจจัย ในปีการผลิต
  fmgetFactor() {
    let fmcode = this.s_fmcode
    if (fmcode) {
      this.spinner.show();
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor6667]&w=[fmcode]='" + fmcode + "'and[getFert3]='Y'" + " order by datepost desc ";
      axios.get(url).then(res => {
        if(res.data.length>0){
          this.fmgetFactorNow = res.data;
          setTimeout(() => {
            $(this.tb_fmgetFactor.nativeElement).DataTable();
          }, 10);
        }
        else this.fmgetFactorNow=[];
      }).catch(err => { console.log(err); })
      this.spinner.hide();
    }
  };

  modalGetfert3(itid: any) {
    $("#md_getfert3").modal('show');
    this.cpbyone = this.cpdata.filter((el: { itid: any; }) => el.itid == itid);
    // console.log('cpbyone: ',this.cpbyone);
  };

  money_amt=0;
  sum_money_amt(f){
    let fert = this.chemicaData.filter(el => el.stock_id == f.get1);
    //console.log('fert : ',fert);
    //console.log('fs : ',f);
    if(fert.length == 0){}
    else if(f.stockid === '00'){
      this.money_amt=f.amt1*fert[0].amt_in
    }
    else if(f.stockid.length > 0){
      this.money_amt=f.amt1*fert[0].amt_out 
    }
  }

  saveGetfert3(f: any) {
    console.log('f : ',f);
    let ma = this.money_amt;
    this.checkOver(f);
    if (this.ckOver) {
      Swal.fire({
        title: 'ยืนยันการบันทึกข้อมูล?',
        text: 'You will not be able to recover this file!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'OK ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='"
          + f.hsupcode + "'&factor_type=2&itid='" + f.hitid + "'&intlandno='" + f.hintlandno + "'&fmcode='" + f.hfmcode +
          "'&YearID='6667'&stockid='" + f.stockid + "'&doc_status=8&get1='" + f.get1 + "'&amt1=" + f.amt1 +
          "&take_method='" + f.take_method + "'&money_amt=" + ma + "&getFert3='Y'";
          axios.get(url).then(res => {
            if (res.data.rowsAffected > 0) {
              Swal.fire('Success', 'บันทึกข้อมูลสำเร็จ!', 'success');
              //this.cpGetfert3(this.fmcodeselect);
              this.cpGetfert3(f.hfmcode);
              //this.Loadaskforfactorlist(this.oneplant[0].fmcode);
            } else {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
            }
          }).catch(err => { console.log(err); })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          /*Swal.fire(
            'ยกเลิกการบันทึกข้อมูล',
            'cancle'
          )*/
        }
        this.closemodel();
      })
    }
  };

  cancledata(docid: any) {
    let fmcode = this.s_fmcode;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + docid + "&doc_status=X";
    if (confirm('ต้องยกเลิกรายการนี้ ' + docid + ' ใช่หรือไม่') == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected == 1) {
          alert("ยกเลิกเรียบร้อยแล้วค่ะ ^^");
          this.cpGetfert3(fmcode);
        }
        else if (res.data.code) {
          alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
        }
        else {
          alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
        }
      }).catch(err => { throw (err) })
    }
  }

  checkOver(f: any) {
    const caneleft = this.cpbyone[0].balance_fert3;
    const userInput = f.amt1;
    // console.log('caneleft :', caneleft + ' userInput :', userInput);
    if (userInput > caneleft) {
      Swal.fire('!!No', '!!คุณกรอกจำนวนที่เบิกเกินกว่าที่เบิกได้..', 'error');
      this.ckOver = false;
    } else {
      // Swal.fire('Yes','จำนวนที่ขอเบิกได้ ไม่เกิน','success')
      this.ckOver = true;
    }
  }

  closemodel() {
    $("#md_getfert3").modal('hide');
  }

}
